/// <amd-module name="Build/ApprovalsPanel/LogsViewPanelService" />
import { ILogsViewPanelService } from "Build/ApprovalsPanel/LogsViewPanelService.types"
import * as Resources from "Build/ApprovalsPanel/Resources";
import { getCheckRunStatusIndicatorData, isInternalTaskCheck } from "Build/ApprovalsPanel/Utilities";
import { TaskCheckDetails, TaskCheckData } from "Build/Client/Contracts/DataProvider";
import { getTimelineStatusIndicatorData } from "Build/Common/Library/Indicator";

import { ISection } from "PipelinesUI/LogViewer";

import { ObservableArray } from "VSS/Core/Observable";
import { equals, format } from "VSS/Core/Util/String";
import { Services, VssService } from "VSS/Platform/Context";
import { issueRequest } from "VSS/Platform/Fetch";
import { routeUrl } from "VSS/Platform/Location";

const newLine = "\n";

export class LogsViewPanelService extends VssService implements ILogsViewPanelService {
    public initialize() {
        this._sections = new ObservableArray<ISection>();
    }

    public fetchData(check: TaskCheckDetails, projectId: string): ObservableArray<ISection> {
        const checkEvaluationSections: ISection[] = this._getCheckEvaluationSections(check, projectId);
        checkEvaluationSections.map((section) => {
            this._sections.push(section);
        })

        return this._sections;
    }

    private _getCheckEvaluationSections(check: TaskCheckDetails, projectId: string): ISection[] {

        let checkEvaluationSections: ISection[] = [];
        let attemptToTaskCheckTimelineRecordDataMap = check.taskCheckData.attemptToTaskCheckTimelineRecordDataMap;

        if (check.taskCheckData.hubName != null && attemptToTaskCheckTimelineRecordDataMap)
        {
            // Converting object to list to perform sorting based on attempts.
            const taskCheckTimelineRecordList = Object.keys(attemptToTaskCheckTimelineRecordDataMap).map(attempt => {
                let timelineRecordData = attemptToTaskCheckTimelineRecordDataMap[parseInt(attempt)];
                return {
                    attempt: parseInt(attempt),
                    logId: timelineRecordData.logId,
                    state: timelineRecordData.state,
                    result: timelineRecordData.result
                }
            });

            taskCheckTimelineRecordList.sort((a, b) => b.attempt - a.attempt);

            let showExpandedLogsSection = true;

            taskCheckTimelineRecordList.map((a) => {
                checkEvaluationSections.push({
                    key: "check-evaluation" + a.attempt,
                    title: format(Resources.AttemptFormat, a.attempt.toString()),
                    hasData: true,
                    statusProps: isInternalTaskCheck(check) ? getCheckRunStatusIndicatorData(check.status).statusProps
                                                    : getTimelineStatusIndicatorData(a.state, a.result).statusProps,
                    isExpanded: showExpandedLogsSection,
                    getData: () => {
                        return  this._getEvaluationLogs(check, a.logId, projectId);
                    }
                });

                // Only the first section must be expanded at the initial render
                showExpandedLogsSection = false;
            });
        }

        return checkEvaluationSections;
    }

    private async _getEvaluationLogs(check: TaskCheckDetails, logId: number, projectId: string) {
        const result = await issueRequest(this._getUrl(check.taskCheckData, logId, projectId)).then((result) => {
            return result.json();
        }, (error) => {
            return "";
        });
        return result.value.join("\n");
    }

    private _getUrl(taskCheckData: TaskCheckData, logId:number, projectId: string) {
        return routeUrl(this.pageContext, "ms.vss-build-web.check-logsapi-route", { projectId: projectId, hubName: taskCheckData.hubName.toLowerCase(), planId: taskCheckData.planId, logId: logId.toString() });
    }

    private _sections: ObservableArray<ISection>;
}

Services.add("ILogsViewPanelService", { serviceFactory: LogsViewPanelService });
